export default __webpack_public_path__ + "static/media/OLP(USDC:DAI).c89a843b.png";